import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-produto-kit',
    templateUrl: './produto-kit.component.html',
    styleUrls: ['./produto-kit.component.scss'],
    standalone: false
})
export class ProdutoKitComponent implements OnInit {
  data;
  options;
  condition="0=0"
  constructor(@Inject(MAT_DIALOG_DATA) public ob, public dialogRef:MatDialogRef<any>) { }

  ngOnInit(): void {
    this.data = this.ob['cardRow'];
    this.options = this.ob['options'];


    this.condition = `this.codecontract=${this.data.linha['CODECONTRACT']} and this.codeproduct=${this.data.linha['CODEPRODUCT']}`
  }



  fechar(){
      this.dialogRef.close();
    
  }

}
